import styled from 'styled-components';
import { MotifDropdownItem } from '@ey-xd/motif-react';
import { isMobile } from 'react-device-detect';

export const DropdownDisplayContainer = styled.div`
  display: grid;
  grid-template-columns: 20px;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  grid-column-gap: 8px;
  width: 310px;
  height: 56px;
  padding: 0 0 0 10px;
  border-left: 3px solid #3a3a4a;
  align-items: center;

  &:focus {
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;
    border-left: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
  }
`;

export const DropdownIconContainer = styled.div`
  width: 20px;
  margin-top: 5px;
`;

export const DropdownTextContainer = styled.div`
  text-align: left;
  width: 120px;
  color: #fff;
`;

export const DropdownDueContainer = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  padding-left: 10px;
  justify-self: end;
  align-items: center;
  border-left: 3px solid #3a3a4a;
`;

export const DropdownContainer = styled.div`
  display: grid;
  grid-template-columns: ${isMobile ? '1fr 4fr 3fr' : '20px 120px 110px'};
  gap: 10px;
  align-items: center;
  width: ${isMobile ? 'auto' : '280px'};
`;

export const UserIconContainer = styled.div`
  width: 15px;
  margin-top: 5px;
`;

export const UserTextContainer = styled.div`
  text-align: left;
  width: 90px;
  color: #fff;

  ${({ selected }) => selected && 'color: yellow;'}
`;

export const DueTextContainer = styled.div`
  width: ${isMobile ? 'auto' : '125px'};
`;

export const StyledDropdownItem = styled(MotifDropdownItem)`
  background-color: ${isMobile ? '#1a1a24' : '#2e2e3c'};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${isMobile ? '#2e2e3c' : '#1a1a24'};
    cursor: pointer;
  }

  // 2e2e3c faint
  // 2e2e3c dark

  ${({ selected }) =>
    selected &&
    `background-color: #1A1A24;
     &:hover {
     background-color: #1A1A24;
    }`}
`;

export const MobileUserProfileButton = styled.img`
  width: 25px;
  height: 25px;
  margin-top: 15px;
  margin-right: 10px;
`;

export const PagesText = styled.div`
  padding: 10px 0px 10px 20px;
  background-color: #2e2e38;
`;

export const CloseIconContainer = styled.div`
  position: relative;
  margin-bottom: 50px;
`;

export const DesktopUserListContainer = styled.div`
  height: auto;
  overflow-y: auto;
  max-height: 24vh;

  scrollbar-width: thick; /* Firefox */
  scrollbar-color: #747480 #2e2e3c; /* Firefox: color of scrollbar and background */
`;

export const MobileUserListContainer = styled.div`
  height: auto;
  overflow-y: auto;
  max-height: 95vh;
`;
